// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"474":"RegisterYourBeys","534":"randomizer","552":"rules","644":"account","730":"tournament-ban"}[chunkId] + "." + {"474":"528d567b","534":"bce27811","552":"2c6971a9","644":"094d4147","730":"c31883b1"}[chunkId] + ".js";
};